(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-dose-calcium-balm"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bd-calcium-page').forEach((page) => {
    const mainImage = page.querySelector('.bd-calcium-main-image');
    const thumbs = [...page.querySelectorAll('.bd-calcium-thumb')];
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const showImage = (index) => {
      if (!thumbs.length || !mainImage) return;
      activeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      mainImage.src = thumb.dataset.image;
      mainImage.srcset = '';
      mainImage.alt = thumb.dataset.alt || '';
      thumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    page.querySelector('.bd-calcium-gallery-arrow--prev')?.addEventListener('click', () => showImage(activeIndex - 1));
    page.querySelector('.bd-calcium-gallery-arrow--next')?.addEventListener('click', () => showImage(activeIndex + 1));

    const dateNode = page.querySelector('.bd-calcium-date');
    if (dateNode) dateNode.textContent = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric' }).format(new Date());
    let remaining = 8 * 60;
    const timerNode = page.querySelector('.bd-calcium-timer');
    const updateTimer = () => {
      if (!timerNode) return;
      remaining = remaining <= 0 ? 8 * 60 : remaining - 1;
      const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      timerNode.textContent = `0hr ${minutes}mins ${seconds}sec`;
    };
    updateTimer();
    window.setInterval(updateTimer, 1000);

    page.querySelector('.bd-calcium-final-cta')?.addEventListener('click', () => {
      page.querySelector('.bd-calcium-atf')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
